<form [formGroup]="frm">
  <div class="row">
    <div class="col-6">
      <mat-form-field>
        <input type="text" matInput formControlName="name" placeholder="File Name" (keyup)="notifyChanged($event)" autocomplete="off" />
        <mat-hint>The name for your exported file</mat-hint>
      </mat-form-field>

    </div>
    <div class="col-6" formGroupName="configuration">
      <mat-form-field>
        <mat-select formControlName="type" placeholder="Response Type" (selectionChange)="notifyChanged()">
          <mat-option value="">--</mat-option>
          <mat-option *ngFor="let o of types" [value]="o">{{o | status_humanizer}}</mat-option>
        </mat-select>
        <mat-hint>The response type to the api request.</mat-hint>
      </mat-form-field>
    </div>
  </div>
  <div class="row" formGroupName="configuration" *ngIf="advancedFilters">
    <div class="col-6">
      <mat-form-field>
        <mat-select formControlName="company" placeholder="Company" (selectionChange)="onCompanyChanged()">
          <mat-option value="">--</mat-option>
          <mat-option *ngFor="let o of companies" [value]="o.id">{{o.name | titlecase}}</mat-option>
        </mat-select>
        <mat-hint>The Company the interactions belong to.</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field>
        <mat-select formControlName="campaign" placeholder="Campaign" (selectionChange)="notifyChanged()">
          <mat-option value="">--</mat-option>
          <mat-option *ngFor="let o of campaigns" [value]="o.id">{{o.name | titlecase}}</mat-option>
        </mat-select>
        <mat-hint>The Campaign which generated the interactions.</mat-hint>
      </mat-form-field>
    </div>
  </div>
  <div class="row" formGroupName="configuration">
    <div class="col-6">
      <mat-form-field>
        <input matInput [matDatepicker]="from" formControlName="from" (dateChange)="notifyChanged()" placeholder="Interacted After" autocomplete="off">
        <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
        <mat-datepicker #from disabled="false"></mat-datepicker>
        <mat-hint>Only interactions that occured after the selected date.</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-6">

      <mat-form-field>
        <input matInput [matDatepicker]="until" formControlName="until" (dateChange)="notifyChanged()" placeholder="Interacted Before" autocomplete="off">
        <mat-datepicker-toggle matSuffix [for]="until"></mat-datepicker-toggle>
        <mat-datepicker #until disabled="false"></mat-datepicker>
        <mat-hint>Only interactions that occured before the selected date.</mat-hint>
      </mat-form-field>
    </div>
  </div>
</form>
